import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InputComponent } from 'src/app/components/shared/input/input.component';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { TranslateService } from '@ngx-translate/core';

export type DropdownOptions = Array<DropdownOption>;

export type DropdownOption = {
  display: string;
  value: any;
};

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit {
  @ViewChild(MatAutocompleteTrigger) trigger!: MatAutocompleteTrigger;
  @ViewChild('input') input!: ElementRef;
  @Input() control!: FormControl;
  @Input() label!: string;
  @Input() options!: DropdownOptions;
  @Input() optionsTranslationKey!: string;
  @Input() hideCaret?: boolean = false;
  @Input() error: string | null = '';
  panelOpen = false;
  length = 0;

  @ViewChild(InputComponent) set content(content: InputComponent) {
    if (content) {
      this.otherInputRef = content;
    }
  }

  private otherInputRef!: InputComponent;
  isOther = false;

  constructor(private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.setIsOther(this.control.value);

    this.control.valueChanges.subscribe((val: any) => {
      this.setIsOther(val);
    });
  }

  calculatePanelWidth(): void {
    this.length = this.input.nativeElement.offsetWidth + 65;
  }

  handleOptionSelected(): void {
    this.panelOpen = false;
  }

  handleOpen(): void {
    this.panelOpen = true;
  }

  handleClose(): void {
    this.panelOpen = false;
  }

  openPanel(): void {
    Promise.resolve().then(() => this.trigger.openPanel());
    this.panelOpen = true;
  }

  displayFn(options: DropdownOptions): (value: any) => string {
    return (value: any) => {
      const correspondingOption = options.find(option => option.value === value);
      return correspondingOption ?
        this.translateService.instant(`${this.optionsTranslationKey}.${correspondingOption.display}`)
        : '';
    };
  }

  clearIsOther(): void {
    this.control.reset();
  }

  setIsOther(val: string | null): void {
    if (
      !this.isOther &&
      ['annan', 'annat', 'other'].includes(val ? val.toLowerCase() : '')
    ) {
      this.isOther = true;
      const validators = this.control.validator;
      this.control.clearValidators();
      this.control.patchValue('');
      setTimeout(() => {
        this.control.setValidators(validators);
        this.control.patchValue('');
        this.otherInputRef.inputRef.nativeElement.focus();
      });
    }
    if (this.isOther && val === null) {
      this.isOther = false;
    }
  }
}
